module.exports = __webpack_public_path__ + "img/116.7e3e4539.jpg";